// @ts-nocheck
import React, { useMemo, useState } from "react";
import "./i18n/config";
import App from "./App";
import createAppTheme from "./theme";
import initI18n from "./i18n/config";
import ReactDOM from "react-dom/client";
import CssBaseline from "@mui/material/CssBaseline";
import ThemeModeContext from "./context/ThemeModeContext";
import useLocalizationStore from "./store/zustand/localization";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import AlertNotification from "./components/Alert/Alert";

const root = ReactDOM.createRoot(document.getElementById("root"));

function RootApp() {
  const [mode, setMode] = useState("light");
  const { language } = useLocalizationStore();
  initI18n();
  const colorMode = useMemo(
    () => ({
      mode,
      toggleMode: () =>
        setMode((prev) => (prev === "light" ? "dark" : "light")),
    }),
    [mode]
  );

  const theme = useMemo(() => createAppTheme(mode, language), [mode, language]);

  return (
    <ThemeModeContext.Provider value={colorMode}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AlertNotification />
          <App />
        </ThemeProvider>
      </StyledEngineProvider>
    </ThemeModeContext.Provider>
  );
}

root.render(
  <React.StrictMode>
    <RootApp />
  </React.StrictMode>
);
